import { useApi, createApiHook } from "../utils/apiUtils";

const useUpdateApplicationDates = () => {
  const { apiPatch } = useApi();

  const useApiState = createApiHook(null);

  const { error, startLoading, setResponse } = useApiState();

  const updateApplicationDates = async ({ appId, date_min, date_max }) => {
    startLoading();

    const body = {
      date_min,
      date_max,
    };

    const response = await apiPatch(`/aplicaciones/${appId}/update_dates`, "Error al actualizar las fechas de la aplicación", body);

    setResponse(response);

    return response;
  };

  return {
    updateApplicationDates,
    error,
  };
};

export default useUpdateApplicationDates;
